import React from "react";
import PropTypes from "prop-types";
import moment from "moment/moment";

import {
    DATE_RANGE_ANY,
    DATE_RANGE_CUSTOM,
    DATE_RANGE_LAST_30_DAYS,
    DATE_RANGE_LAST_7_DAYS,
    DATE_RANGE_LAST_90_DAYS,
    DATE_RANGE_TODAY,
    DATE_RANGE_YESTERDAY,
    DATE_RANGES
} from "../../../constants/dates";
import {getRangeFromDates} from "./date_range_utils";
import CustomDropdown from "../CustomDropdown";

const RangeSelector = function (
    {
        onUpdate = ({}) => {
        },
        from = null,
        till = null,
        as = 'selector',
        trigger_class,
        item_class
    }
) {
    const updateRange = function (range) {
        switch (range) {
            case DATE_RANGE_ANY:
                onUpdate({
                    from: null,
                    till: null
                });
                break;
            case DATE_RANGE_TODAY:
                onUpdate({
                    from: moment().startOf('day').unix(),
                    till: moment().endOf('day').unix()
                });
                break;
            case DATE_RANGE_YESTERDAY:
                onUpdate({
                    from: moment().subtract(1, 'd').startOf('day').unix(),
                    till: moment().subtract(1, 'd').endOf('day').unix()
                });
                break;
            case DATE_RANGE_LAST_7_DAYS:
                onUpdate({
                    from: moment().subtract(7, 'd').startOf('day').unix(),
                    till: moment().endOf('day').unix()
                });
                break;
            case DATE_RANGE_LAST_30_DAYS:
                onUpdate({
                    from: moment().subtract(30, 'd').startOf('day').unix(),
                    till: moment().endOf('day').unix()
                });
                break;
            case DATE_RANGE_LAST_90_DAYS:
                onUpdate({
                    from: moment().subtract(90, 'd').startOf('day').unix(),
                    till: moment().endOf('day').unix()
                });
                break;
            case DATE_RANGE_CUSTOM:
                onUpdate({
                    from: moment().subtract(2, 'd').startOf('day').unix(),
                    till: moment().endOf('day').unix()
                });
                break;
        }
    };

    if (as === 'selector') {
        const items = {};
        Object.keys(DATE_RANGES).map(range => {
            items[range] = (
                <div
                    key={range}
                    className={item_class + ' date-range-item ' + (getRangeFromDates(from, till) === range ? 'active' : '')}
                    onClick={event => {
                        event.preventDefault();
                        updateRange(range);
                    }}
                >{DATE_RANGES[range]}</div>
            )
        });
        return (
            <CustomDropdown
                trigger={(
                    <div className={trigger_class + " range-selector-trigger"}>
                        <span className='no-wrap'>
                            {DATE_RANGES[getRangeFromDates(from, till)]}
                        </span>
                    </div>
                )}
                no_wrap={true}
                items={items}
            />
        );
    } else {
        return (
            <div className='mindsets-date-range-selector-picker'>
                {Object.keys(DATE_RANGES).map(range => {
                    return (
                        <div
                            key={range}
                            className={item_class + ' date-range-item ' + (getRangeFromDates(from, till) === range ? 'active' : '')}
                            onClick={event => {
                                event.preventDefault();
                                updateRange(range);
                            }}
                        >{DATE_RANGES[range]}</div>
                    );
                })}
            </div>
        );
    }
}

RangeSelector.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    from: PropTypes.number,
    till: PropTypes.number,
    as: PropTypes.oneOf(['selector', 'buttons']),
    trigger_class: PropTypes.string,
    item_class: PropTypes.string
}

export default RangeSelector;
